<template>
  <form v-on:submit.prevent="saveForm" novalidate>
    <div class="form-row">
      <div
        class="form-group col-12 col-md-6"
        :class="{ 'is-invalid': $v.name.$error }"
      >
        <label :for="'indication-input-name' + _uid"
          ><span>*</span> Nombre de quien recomendó</label
        >
        <input
          type="text"
          class="form-control"
          :id="'indication-input-name' + _uid"
          v-model="name"
        />

        <small v-if="$v.name.$error">
          Informe el nombre de quien lo recomendó
        </small>
      </div>

      <div
        class="form-group col-12 col-md-6"
        :class="{ 'is-invalid': $v.email.$error }"
      >
        <label :for="'indication-input-email' + _uid"
          ><span>*</span> Correo electrónico de quien lo recomendó</label
        >
        <input
          type="email"
          class="form-control"
          :id="'indication-input-email' + _uid"
          v-model="email"
        />

        <small v-html="emailValidationErrorMsg"></small>
      </div>
    </div>
  </form>
</template>

<script>
  import { validationMixin } from "vuelidate";
  import { required, requiredIf } from 'vuelidate/lib/validators';

  export default {
    name: "FormIndication",

    data() {
      return {
        name: "",
        email: "",
      };
    },

    computed: {
      indicationDomains() {
        return this.$store.state.opportunities.currentOpportunity.indication_domains || [];
      },

      emailValidationErrorMsg() {
        if ( this.$v.email.$error ) {
          if (this.email == '') {
            return 'Informe el correo electrónico de quien lo indicó'
          }

          if (!this.$helpers.isEmail(this.email)) {
            return 'Correo electrónico no válido'
          }

          const emailDomain = this.email.split('@')[1];
          const valid = this.indicationDomains.includes(emailDomain)
          
          if (!valid) {
            return `Solo son válidos los siguientes dominios <br />
            <strong>${this.indicationDomains.map((d) => `@${d}`).join(', ')}</strong>`;
          }
        }

        return null;
      },
    },

    mixins: [validationMixin],

    validations: {
      name: {
        required: requiredIf(function (value) {
          return this.email != null && this.email !== '';
        }),
      },
      email: {
        required: requiredIf(function (value) {
          return this.name != null && this.name !== '';
        }),
        validateIndicationMail: (mail, _this) => {
          if (mail != '' && !_this.$helpers.isEmail(mail)) return false;
          if (mail == '' || _this.indicationDomains.length == 0) return true;

          const emailDomain = mail.split('@')[1];
          return _this.indicationDomains.includes(emailDomain)
        }
      },
    },

    mounted() {
      this.initListeners();
    },

    destroyed() {
      this.$EventBus.$off("storeIndication");
    },

    methods: {
      initListeners() {
        this.$EventBus.$on("storeIndication", this.storeForm);
      },

      storeForm() {
        this.$v.$touch();

        if (this.$v.$invalid) {
          this.$store.commit("INDICATION_FORM", {
            error: true,
          });

          setTimeout(() => {
            Array.from(this.$el.querySelectorAll(".is-invalid")).some((field) => {
              field.querySelector("input").focus();
              return field;
            });
          }, 100);
        } else {
          this.$store.commit("INDICATION_FORM", {
            data: this.$data,
          });
        }
      },
    },
  };
</script>

<style lang="scss" scoped></style>
